import { createAction, props } from '@ngrx/store';

export const EnableHighContrast = createAction('[Contrast] enable high contrast');
export const DisableHighContrast = createAction('[Contrast] disable high contrast');

export const ToggleHighContrast = createAction('[Contrast] toggle high contrast');
